
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ConfirmationDialog',
  emits: ['confirmed', 'canceled'],
  props: {
    okText: {
      type: String,
      default: 'Confirm'
    },
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    okButtonDisabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  }
})
